<template>
  <div class="mask">
    <div class="interna-invitation">
      <div @click="onClose" class="close">
        <i class="iconfont icondanchuang_guanbi"></i>
      </div>
      <div class="invitation-play">
        <video :src="url" :controls="controls" ref="invitationVideo" autoplay="autoplay" muted></video>
        <div class="play-mask" v-if="!controls">
          <div class="play-icon" @click="onPlay">
            <i class="iconfont iconyinpinku_bofang"></i>
          </div>
        </div>
      </div>
      <div class="title">来画动画v6.0.0内测诚邀您加入体验！</div>
      <div class="invitation-text">
        · 全新性能升级，创作更丝滑
        <br />
        · 时间轴改版，精度至0.1s，动画时长自定义，人物多动作衔接
        <br />
        · 单个场景页无时间上限，创作不受限
        <br />
        · 更多精彩，等你来发现！
        <br />
      </div>
      <div class="invitation-btn">
        <div class="no-join" @click="onClose">暂不参与</div>
        <div class="join" @click="onconfirm">参与内测</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "InternaInvitation",
  data() {
    return {
      controls: true,
      url: "https://resources.laihua.com/2022-9-29/be7b9530-3fa4-11ed-94e0-1dbd063a0026.mp4"
    };
  },
  computed: {
    ...mapGetters([
      'TopnavMsg'
    ])
  },
  created() {
    sensors.track('laipicBetaInvitation');
  },
  methods: {
    onClose() {
      localStorage.setItem("invitation", "true");
      this.$store.commit('save_TopnavMsg', {
        isInternaInvitation: false
      });
    },
    onPlay() {
      this.$refs.invitationVideo.play();
      this.controls = true;
    },
    onconfirm() {
      this.$bus.emit('versionSwitch','invitationPopup');
      this.onClose();
    }
  }
};
</script>
<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.5);
  .interna-invitation {
    width: 566px;
    height: 596px;
    background: #ffffff;
    border-radius: 6px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background-image: url("/static/img/internal-bg.png");
    // background-repeat: no-repeat;
    // background-size: 100% 259px;
    .close {
      position: absolute;
      right: -32px;
      top: -14px;
      width: 28px;
      height: 28px;
      background: #efefef;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      i {
        font-size: 28px;
        color: #5b6070;
      }
    }
    .invitation-btn {
      line-height: 36px;
      margin-top: 40px;
      display: flex;
      justify-content: center;
      .no-join {
        cursor: pointer;
        width: 116px;
        height: 36px;
        background: #f2f3f7;
        color: #272d4d;
        border-radius: 4px;
        margin-right: 30px;
      }
      .join {
        cursor: pointer;
        width: 116px;
        height: 36px;
        color: #ffffff;
        background: #6464f8;
        border-radius: 4px;
      }
    }
    .invitation-text {
      padding-left: 42px;
      text-align: left;
      font-size: 14px;
      line-height: 23px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #272d4d;
    }
    .invitation-play {
      width: 100%;
      height: 318px;
      margin-bottom: 38px;
      border-radius: 6px 6px 0px 0px;
      background-color: pink;
      overflow: hidden;
      // position: absolute;
      .play-mask {
        position: absolute;
        top: 0;
        left: 0;
        height: 318px;
        width: 100%;
        background: rgba($color: #000000, $alpha: 0.4);
        border-radius: 6px 6px 0px 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        .play-icon {
          cursor: pointer;
          width: 48px;
          height: 48px;
          background: #ffffff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0.8;
          i {
            font-size: 26px;
            color: #6464f8;
          }
        }
      }
    }
    .title {
      padding-left: 42px;
      text-align: left;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #272d4d;
      margin-bottom: 14px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/popups/internalInvitation.vue